import { useState } from 'react';

import type { JobDetails } from '@/api/fe-api/domain/entities/capacity-evaluation';
import type { Site } from '@/api/fe-api/domain/entities/site';
import { Card } from '@/components/ui/card';

import { CapacityTestResultsAggregated } from './capacity-test-results-aggregated';
import { LevelSelect } from './level-select';

export type CapacityTestResultsProps = {
  jobDetails: JobDetails;
  asset: Site;
};

export function CapacityTestResults({
  jobDetails,
  asset,
}: CapacityTestResultsProps) {
  const [level, setLevel] = useState<string | undefined>(undefined);

  if (jobDetails.status !== 'Completed') {
    return null;
  }

  return (
    <Card className="space-y-8">
      <div className="flex items-end justify-between">
        <h3 className="text-xl font-semibold">Detailed Test Results</h3>
        <LevelSelect jobId={jobDetails.id} value={level} onChange={setLevel} />
      </div>
      {level ? (
        <CapacityTestResultsAggregated
          capacityTest={jobDetails}
          asset={asset}
          level={level}
        />
      ) : null}
    </Card>
  );
}
